export default {
  brewery: 'aleApothecary',
  info_url: 'http://landing.tavour.com/aleApothecary/',
  title: {
    in_progress: '',
    success: 'You Joined The Ale Apothecary Experience!',
    subtext: 'The Ale Apothecary Experience',
    sub_subtext: "Join 'The Ale Apothecary Experience'! " +
      'How does one of the smallest breweries become a global icon? ' +
      'See for yourself with award-winning brands that made our brewery ' +
      "famous as well as specialty one-off creations, all pushing the boundaries of what defines 'beer'. " +
      'Members receive two 375ml bottles of three distinct brands for a total of 6 bottles every quarter.',
  },
  review: {
    summary: [
      'You are joining The Ale Apothecary Experience where you will receive two ' +
      '375ml bottles of three different brands 4x per year for $90 (including shipping). ' +
      'By signing up, your credit card will be automatically charged $90.  ' +
      'You will have the opportunity to \'opt out\' before your credit card is charged by ' +
      'emailing support@tavour.com.' +
      'You\'ll receive a notification via email when the box has been charged and shipped. ',
    ],
    button_text: 'Join The Ale Apothecary Experience!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/ale_apothecary.js